import { runtimeEventBus } from '../services/runtimeEventBus';
/**
 * Extends an app loader to allow the runtime to tidy up event subscriptions when stopping an app
 * @param LoaderConstructor
 */
export function extendAppLoader(LoaderConstructor) {
    return class extends LoaderConstructor {
        async unload() {
            try {
                const result = await super.unload();
                return result;
            }
            finally {
                runtimeEventBus.unsubscribeInstance(this.config.appConfig.instanceId);
            }
        }
    };
}
//# sourceMappingURL=extendAppLoader.js.map